import { clsx } from "clsx";

export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_853bc765-6a56-4538-ad3e-7e7d0cc9308f/artifacts/lmkuu8zn_IMG-20260929-WA0009.jpg";

export function Logo({ size = 40, showText = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img src={LOGO_URL} alt="BeetDrop" style={{ width: size, height: size }}
        className="rounded-xl object-cover ring-1 ring-[#451B7F]" />
      {showText && <span className="font-head text-xl font-extrabold tracking-tight text-white">Beet<span className="bd-grad-text">Drop</span></span>}
    </div>
  );
}

export function Btn({ variant = "primary", className, children, ...props }) {
  const base = "rounded-xl font-semibold text-sm inline-flex items-center justify-center gap-2 transition-colors duration-200 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none";
  const styles = {
    primary: "px-5 py-2.5 text-white bg-gradient-to-r from-[#FF5E36] via-[#FF2A6D] to-[#FF1E56] hover:brightness-110 shadow-[0_0_20px_rgba(255,42,109,0.25)]",
    secondary: "px-5 py-2.5 text-purple-100 bg-[#250B4C] hover:bg-[#320E66] border border-[#421683]",
    outline: "px-4 py-2 text-purple-200 border border-[#521E9E] hover:border-[#FF5E36] hover:text-white",
    ghost: "px-3 py-1.5 text-purple-200 hover:text-white hover:bg-[#250B4C]",
    danger: "px-4 py-2 text-rose-100 bg-rose-600/20 border border-rose-500/40 hover:bg-rose-600/30",
  };
  return <button className={clsx(base, styles[variant], className)} {...props}>{children}</button>;
}

export function Panel({ className, children, ...props }) {
  return <div className={clsx("rounded-2xl bg-[#180735] border border-[#2E1256] shadow-xl", className)} {...props}>{children}</div>;
}

export function Field({ label, children, hint }) {
  return (
    <label className="block space-y-1.5">
      {label && <span className="text-xs font-semibold tracking-wider uppercase text-purple-300/70">{label}</span>}
      {children}
      {hint && <span className="block text-xs text-purple-400/60">{hint}</span>}
    </label>
  );
}

const inputCls = "w-full bg-[#120429] border border-[#361368] rounded-xl px-4 py-2.5 text-white placeholder-purple-400/40 focus:outline-none focus:border-[#FF2A6D] focus:ring-1 focus:ring-[#FF2A6D] transition-colors duration-200 text-sm";
export function Input(props) { return <input className={inputCls} {...props} />; }
export function TextArea(props) { return <textarea className={inputCls + " min-h-[90px]"} {...props} />; }
export function Select({ children, ...props }) { return <select className={inputCls} {...props}>{children}</select>; }

const STATUS = {
  pending: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  assigned: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  in_progress: "bg-purple-500/15 text-purple-300 border-purple-500/30",
  resolved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  completed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  rejected: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  open: "bg-rose-500/15 text-rose-300 border-rose-500/30",
};
export function StatusBadge({ status }) {
  const label = String(status || "").replace(/_/g, " ");
  return <span data-testid={`status-${status}`} className={clsx("inline-flex px-2.5 py-1 rounded-full text-[11px] font-semibold border capitalize", STATUS[status] || "bg-purple-500/15 text-purple-200 border-purple-500/30")}>{label}</span>;
}

export function AllergyFlag({ info }) {
  if (!info) return null;
  return <span data-testid="allergy-flag" className="inline-flex items-center gap-1 bg-rose-950/80 text-rose-200 border border-rose-500/60 animate-pulse px-2.5 py-1 rounded-full text-[11px] font-bold">⚠ {info}</span>;
}
